export default "__VITE_ASSET__gQZExx9O__"